<div [formGroup]="form"  [ngClass]="{'textbox-container-medium': !isSmallView}"
  class="textbox-container" matTooltip={{field.value}} [matTooltipDisabled]="!showTooltip" matTooltipPosition="right"
  matTooltipClass="tooltipClass">
  <mat-form-field appearance="fill" [ngClass]="{'mat-form-field-readonly':true}">
    <mat-label id="matLabel" [innerHTML]="field.label | safeHtml"></mat-label>
    <input class="truncateBigWord"  type="text" matInput [value]="field.value" formControlName="{{field.key}}" [id]="field.key"
      [readonly]="field.readOnly"  [attr.maxLength]="field.maxLength !== undefined && field.maxLength > 0 ? field.maxLength : null" />
    <span matPrefix *ngIf="field.iconName !=''">
      <mat-icon id="iconName" matPrefix>{{field.iconName}}</mat-icon>
    </span>
    <mat-error id="matError">{{getSpecificErrorMessage()}}</mat-error>
  </mat-form-field>  
</div>